var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgD207B8Fbfd66032909Fbe79073F45685(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7023 21.2977C17.7731 28.3685 24.5277 29.8646 27.0208 30C28.6131 27.6662 29.2869 25.7392 29.74 24.0169C28.0177 22.34 25.51 20.6285 23.2131 19.6654L20.4939 22.3854C19.5646 22.1362 17.0146 21.0823 13.9662 18.0339C10.9185 14.9862 9.86385 12.4362 9.61462 11.5069L12.3346 8.78693C11.3715 6.48924 9.66 3.98232 7.98308 2.26001C6.26077 2.71309 4.33385 3.38616 2 4.98001C2.13615 7.47232 3.63154 14.2262 10.7023 21.2977Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6923 0V6.15385",
    stroke: "#E37021",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 12.3076H25.8462",
    stroke: "#E37021",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3507 6.15381L25.0215 9.23073",
    stroke: "#E37021",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8462 1.64917L22.7693 6.9784",
    stroke: "#E37021",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgD207B8Fbfd66032909Fbe79073F45685);
export default __webpack_public_path__ + "static/media/d207b8fbfd66032909fbe79073f45685.8704328fc54a77d21fff394414dd3a22.svg";
export { ForwardRef as ReactComponent };